import React from "react";
import { useAppBridge } from "@shopify/app-bridge-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ExitIFrame({redirectUrl}) {
    const app = useAppBridge();
    const { search } = useLocation();

    useEffect(() => {
        redirectIframe(redirectUrl, app);
    }, [app, search, redirectUrl]);

    app.loading(true);
    
    return <></>;
}

export function redirectIframe(redirectUrl, app) {
    if (!!app) {
        window.open(decodeURIComponent(redirectUrl), '_top');
    }
    else {
        console.error(`Cannot redirect to ${redirectUrl} because app is undefined`);
    }
}

export function redirectLocal(redirectUrl, app) {
    if (!!app) {
        window.open(decodeURIComponent(redirectUrl), '_top');
    }
    else {
        console.error(`Cannot redirect to ${redirectUrl} because app is undefined`);
    }
}